"use strict";
/**
 * @module Topics
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var topic_specification_info_1 = require("./../../topics/details/topic-specification-info");
var TopicSpecificationSerialiser = require("./../../topics/details/topic-specification-serialiser");
/**
 * Serialiser for {@link TopicSpecificationInfo}
 */
var TopicSpecificationInfoSerialiserClass = /** @class */ (function (_super) {
    __extends(TopicSpecificationInfoSerialiserClass, _super);
    function TopicSpecificationInfoSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link TopicSpecificationInfo} from the stream
     *
     * @param bis the input stream
     * @return    the {@link TopicSpecificationInfo} that was read
     */
    TopicSpecificationInfoSerialiserClass.prototype.read = function (bis) {
        var topicId = Codec.readInt32(bis);
        var path = Codec.readString(bis);
        var spec = TopicSpecificationSerialiser.read(bis);
        return new topic_specification_info_1.TopicSpecificationInfo(topicId, path, spec);
    };
    /**
     * Write a {@link TopicSpecificationInfo} to the stream
     *
     * @param bos   the output stream
     * @param value the {@link TopicSpecificationInfo} to be written
     */
    TopicSpecificationInfoSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeInt32(bos, value.id);
        Codec.writeString(bos, value.path);
        TopicSpecificationSerialiser.write(bos, value.specification);
    };
    return TopicSpecificationInfoSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.TopicSpecificationInfoSerialiserClass = TopicSpecificationInfoSerialiserClass;
/**
 * The {@link TopicSpecificationInfoSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.TopicSpecificationInfoSerialiser = new TopicSpecificationInfoSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/topics/details/topic-specification-info-serialiser.js
// module id = 2092
// module chunks = 1